import { InfiniteTable } from '@/components/_common';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import { useMailWorkorderList } from '@/core/domain/mail/MailControler/MailControler.hooks';
import { Mail } from '@/core/domain/mail/MailControler/MailControler.types';
import { useRouteMatchParam } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { COLUMNS_WIDTH } from '@/utils/table';
import { Button, Divider, Space, Tooltip } from 'antd';
import moment from 'moment';
import { Download } from 'react-feather';
import { v4 } from 'uuid';

type Props = {
  onMailSelect: (mail: Mail) => void;
};

const WorkOrderMailList: React.FC<Props> = ({ onMailSelect }) => {
  const workorderId = +useRouteMatchParam('workOrderId');
  const { data, isLoading, hasNextPage, fetchNextPage } = useMailWorkorderList({
    workorderId,
  });
  const mails = flatInfiniteData(data);

  function downloadPDF(pdf: string, fileName?: string) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement('a');
    let _fileName = '';

    if (fileName) {
      _fileName = fileName.replace(/\.[^/.]+$/, '');
    }

    _fileName = `${_fileName || v4()}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = _fileName;
    downloadLink.click();
  }

  return (
    <InfiniteTable
      dataSource={mails}
      loading={isLoading}
      columns={[
        {
          key: 'from',
          dataIndex: 'from',
          title: 'Remetente',
          width: COLUMNS_WIDTH.default,
        },
        {
          key: 'to',
          dataIndex: 'to',
          title: 'Destinatário',
          width: COLUMNS_WIDTH.default,
        },
        {
          key: 'subject',
          dataIndex: 'subject',
          title: 'Assunto',
          width: COLUMNS_WIDTH.default,
        },
        {
          key: 'sentDate',
          dataIndex: 'sentDate',
          title: 'Data de envio',
          width: COLUMNS_WIDTH.default,
          render: (date) => moment(date).format(`DD/MM/YYYY HH:mm`),
        },
        {
          key: 'action',
          title: 'Ação',
          width: 204,
          align: 'right',
          render: (_, item) => (
            <Space align="end">
              {!!item.attachments?.length && (
                <Tooltip title="Baixar PDF do orçamento">
                  <Button
                    icon={<AntdFeatherIcon icon={<Download />} size={17} />}
                    onClick={() =>
                      item.attachments
                        ? downloadPDF(item.attachments[0].content)
                        : undefined
                    }
                  />
                </Tooltip>
              )}

              <Divider type="vertical" />

              <Button onClick={() => onMailSelect(item)}>Visualizar</Button>
            </Space>
          ),
        },
      ]}
      rowKey={(row) => row.id}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
    />
  );
};

export default WorkOrderMailList;
